"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RedirectionService {
    constructor() {
        this.helpCenter = 'https://info.biomemakers.com/support';
    }
    redirect(url) {
        window.location.href = url;
    }
    open(url) {
        window.open(url);
    }
    helpCenterOpen(param = null) {
        if (param)
            this.open(`${this.helpCenter}/kb-search-results?term=${param}`);
        else
            this.open(`${this.helpCenter}`);
    }
}
exports.default = RedirectionService;
